import { api } from '../../lib/api.ts';

export interface Payment {
  requestId: string;
  refNumber: string;
  title: string;
  winnerVendorName: string;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  confirmedBankName: string | null;
  confirmedBankNumber: string | null;
  invoiceConfirmedAt: string | null;
  amount: number;
  sentToFinanceAt: string;
  paid: boolean;
  paidAt: string | null;
  gsrNumber: string | null;
  prNumber: string | null;
}

export type PaymentDocKind = 'PV' | 'SLIP' | 'OTHER';

export interface PaymentDoc {
  id: string;
  kind: PaymentDocKind;
  fileName: string;
  mime: string;
  size: number;
  sortOrder: number;
  uploadedAt: string;
}

export const paymentsApi = {
  list: () =>
    api.get<{ payments: Payment[] }>('/payments').then((r) => r.data.payments),
  setPaid: (requestId: string, paid: boolean) =>
    api
      .patch<{ award: { paid: boolean; paidAt: string | null } }>(`/requests/${requestId}/award/paid`, { paid })
      .then((r) => r.data.award),
  packageUrl: (requestId: string) => `/requests/${requestId}/payment-package.pdf`,
  // ── Finance payment documents (PV / Slip / Other) ─────────────────────────
  listDocs: (requestId: string) =>
    api.get<{ docs: PaymentDoc[] }>(`/requests/${requestId}/award/payment-docs`).then((r) => r.data.docs),
  uploadDoc: (requestId: string, body: { kind: PaymentDocKind; fileName: string; mime: string; dataBase64: string }) =>
    api.post<{ doc: PaymentDoc }>(`/requests/${requestId}/award/payment-docs`, body).then((r) => r.data.doc),
  deleteDoc: (requestId: string, docId: string) =>
    api.delete(`/requests/${requestId}/award/payment-docs/${docId}`).then(() => undefined),
};
